/**
 * Храним флаг принятия политики cookie
 */
export const cookiePolicyStorageKey = "mg_uac";
export const cookiePolicyRoute = "/cookie-policy";

/**
 * Данные для страницы cookie.
 * https://omni-web.k8s.dev.mos.corp/docs#/configurator-api/configuratorApiGetV1WebCommonContentCookies
 */
export const cookiePolicyApi = "/v1/web-common-content/cookies";

export function getCookiePolicyMeta(projectName: string) {
  return {
    title: `Cookies на ${projectName}`,
    description:
      "Мы используем cookies. Они делают сайт удобнее, запоминают данные для входа и ваши настройки. Узнайте подробнее",
  };
}
